import * as Yup from 'yup';

export default Yup.object().shape({
  id: Yup.number(),
  label: Yup.string().required('Footer label is required').max(250),
  to: Yup.string().required('Link is required').max(500),
});